export default __webpack_public_path__ + "static/media/java.9993276d.PNG";